import functions from "./functions.js";
import calendar from './calendar.js';
import lozad from 'lozad';
import inputGuests from "./input-guests.js";

$(function () {
    details.init();
});

const details = {
    response : null,
    $form : null,
    form : null,
    loadedCalendar: 0,
    params : {
        objectGroupId : null,
        publicId : null,
        typeId : null,
        unitId : null,
        dateFrom : null,
        dateTo : null,
        guests : '2,0',
        persons : null,
        lang: functions.getLang(),
    },
    init() {
        if(!$('.page-type-details')[0]) return;

        details.$form = $('form');
        details.form = details.$form[0];

        details.params.objectGroupId = details.$form.attr('data-objectgroupid');
        details.params.publicId = details.$form.attr('data-publicid');
        details.params.unitId = details.$form.attr('data-unitid');
        
        details.getParams();

        // VILLA
        if ($('.book-range')[0] && details.params.dateFrom) {
            details.params.dateFrom += ' - ' + details.params.dateTo;
        }
        if(details.params.objectGroupId == 1) {
            functions.setFormData(details.form, details.params);
            //details.getCalculation(null);
        }

        if(details.params.unitItem) {
            functions.scrollToElement(details.params.unitItem, 100);
        }

        if ($('.details-unit-slider')[0]) {
            $('.details-unit-slider').lightSlider({
                item: 1,
                controls: true,
                mode: 'fade',
                slideMargin: 0,
                pauseOnHover: false,
                auto: false,
                enableDrag: false,
                pager: false,
                loop: true,
            });
        }

        if ($('.details-itinerary-slider')[0]) {
            $('.details-itinerary-slider').lightSlider({
                item: 1,
                slideMargin: 0,
                controls: true,
                mode: 'fade',
                loop: true,
                //prevHtml: '<i class="las la-angle-left"></i>',
                //nextHtml: '<i class="las la-angle-right"></i>',
            });
        }

        // VILLA
        if ($('.book-range')[0]) {
            let config = JSON.parse(details.$form.attr('data-calendarConfig'));
    
            calendar.calendar.init(
                $('.book-range'),
                {
                    availabilityMask: config.availabilityMask,
                    periods: config.periods,
                    translations: config.translations,
                    containerClass: 'details-booking-calendar pl-2 pr-3 py-2'
                },
                details.getCalculation(null)
            );

            details.$form.on('change', e => {
                functions.setUrlData(functions.getFormData($(e.target).parents('form')), true);
            });

            if (details.params.dateFrom) {
                if (details.params.persons) details.params.guests = details.params.persons + ',0';
                details.params.dateTo = details.params.dateFrom.split(' - ')[1];
                details.params.dateFrom = details.params.dateFrom.split(' - ')[0];

                details.getCalculation(null);
            }

            $(window).on('hashchange', () => {
                details.getParams();

                details.params.guests = '2,0';
                if (details.params.persons) details.params.guests = details.params.persons + ',0';
                details.params.dateTo = details.params.dateFrom.split(' - ')[1];
                details.params.dateFrom = details.params.dateFrom.split(' - ')[0];

                details.getCalculation(null);
            });

            details.setBookingUrlParams();
        }

        // EXCURSIONS
        const $bookingItem = $('#booking-accordion').find('.show');
        if (details.params.objectGroupId == 6) {
            details.params.typeId = details.$form.attr('data-typeid');

            // CRUISES
            if (details.params.typeId == 51) {
                //details.getDefaults();
                details.setPrices();
                $(window).on('hashchange', details.setPrices);

            } else {
                details.setCalculationParams($bookingItem);
                
                $('#booking-accordion').on('shown.bs.collapse', e => {
                    functions.setUrlData(functions.getFormData($(e.target)), true);
                    details.getParams();
                    details.setCalculationParams($(e.target));
                    details.getCalculation();
                    details.setBookingUrlParams();
                });

                details.getCalculation(details.params.unitId);
            }

        }

        if (details.params.objectGroupId == 6) {
            //details.getParams();
            //functions.setFormData(details.form, details.params);
            
            details.onFormChange(details.$form);

            details.setBookingUrlParams();
            if (!details.params.typeId == 51) {
                details.setCalculationParams($bookingItem);
            }

            details.getCalculation(details.params.unitId);

        } else if (details.params.objectGroupId == 1 && !$('.book-range')[0]) {

            // datepicker-range
            if(details.params.dateFrom) {
                if(details.params.dateFrom.split(' - ')[1]) {
                    details.params.dateTo = details.params.dateFrom.split(' - ')[1];
                    details.params.dateFrom = details.params.dateFrom.split(' - ')[0];
                }
                //details.params.guests += ',0';
                if (details.params.persons) details.params.guests = details.params.persons + ',0';
            }

            if($('.form-arrangement')[0]) {
                $('#booking-accordion').on('shown.bs.collapse', e => {
                    let formData = functions.getFormData($(e.target));
                    details.onFormChange($('.form-arrangement'));
                    if(details.params.dateFrom) {
                        details.setBookingUrlParams();
                        //details.setCalculationParams($(e.target));
                    }
                    
                    details.params.unitId = $(e.target).attr('data-unitid');
                    
                    if(formData.dateFrom == '') {
                        $('.calculated-price-' + details.params.unitId).text('---');
                        $('.dual-price-' + details.params.unitId).addClass('d-none');
                    }
                    details.params.dateFrom = formData.dateFrom;

                    details.params.dateTo = details.params.dateFrom.split(' - ')[1];
                    details.params.dateFrom = details.params.dateFrom.split(' - ')[0];

                    if (!details.params.dateTo) details.params.dateTo = details.params.dateFrom;

                    //details.setCalculationParams($(e.target));
                    details.params.objectGroupId = $(e.target).attr('data-objectgroupid');
                    details.params.unitId = $(e.target).attr('data-unitid');
                    

                    details.getCalculation(details.params.unitId);

                }); 
            } 

            details.onFormSubmit(details.$form);
            details.setBookingUrlParams();
            details.getCalculation(null);

        }

        $('.btn-print').on('click', e => {
            window.focus();
            window.print();
        });

        // instance of cruise units slider
        let $unitSlider = null;

        $('.collapse-cruise').on('hide.bs.collapse', e => {
            if ($unitSlider.length) {
                $unitSlider.destroy();
            }
        });

        $('.collapse-cruise').on('show.bs.collapse', e => {

            $unitSlider = $(e.target).find('.excursion-unit-detail');

            if ($unitSlider.length) {
                $unitSlider.lightSlider({
                    item: 3,
                    slideMargin: 2,
                    loop: false,
                    auto: false,
                    pager: false,
                    enableDrag: false,
                    controls: true,
                    prevHtml: '<i class="las la-angle-left text-white p-1 rounded" style="font-size: 1.8rem; background-color: #393844cc;"></i>',
                    nextHtml: '<i class="las la-angle-right text-white p-1 rounded" style="font-size: 1.8rem; background-color: #393844cc;"></i>',
                    responsive: [
                        {
                            breakpoint: 1200,
                            settings: {
                                item: 2
                            }
                        },
                        {
                            breakpoint: 1000,
                            settings: {
                                item: 1
                            }
                        }
                    ]
                });
            }


        });
        
    },
    getParams() {
        $.extend(details.params, functions.getUrlData(true));
    },
    // CRUISES
    /*getDefaults() {
        let defaults = $('.form-cruise').attr('data-params');
        defaults = defaults ? JSON.parse(defaults) : {};
        details.params = $.extend({}, details.params, defaults);
    },*/
    // CRUISES - SET UNIT PRICES
    setPrices() {

        let allPrices = JSON.parse($('.base-prices-units').attr('data-basepricesunits'));

        $('.d-none').removeClass('d-block');

        //$('.spinner').removeClass('d-none');

        let
            unitId = null,
            dateFrom = null,
            price = null,
            percent = null,
            calcPrice = null;

        Object.values(allPrices).forEach(function (item) {

            unitId = item['unitId']['id'];
            dateFrom = item['dateFrom'];
            details.params.dateTo = item['dateTo'];

            if (details.params.dateFrom == dateFrom) {

                price = item['price'];
                percent = item['percent'];
                calcPrice = percent ? price - (price * percent / 100) : null;

                $('.price-unitID-' + unitId)
                    .text(functions.formatMoney(calcPrice ? calcPrice : price, 2, ',', '.'));

                $('.discounted-unitID-' + unitId)
                    .text(calcPrice ? functions.formatMoney(price, 2, ',', '.') : null);

                $('#' + unitId).addClass('d-block');
            }

        });

    },
    onFormChange($form) {
        // details.$form
        $form.on('change', e => {
            
            functions.setUrlData(functions.getFormData($(e.target)), true);
            details.getParams();

            // CRUISES
            if(details.params.typeId == 51) {
                const $option = $(e.target).find('option[value="' + details.params.dateFrom + '"]');
                details.params.dateTo = $option.attr('params-date-to');
            } else if(details.params.objectGroupId == 1 || details.params.dateFrom.split(' - ').length > 1) {
                details.params.dateTo = details.params.dateFrom.split(' - ')[1];
                details.params.dateFrom = details.params.dateFrom.split(' - ')[0];
            }

            if (!details.params.dateTo) details.params.dateTo = details.params.dateFrom;

            details.getCalculation(details.params.unitId);
            //details.getCalculation(null);
        });
    },
    onFormSubmit($form) {
        $form.on('submit', e => {
            e.preventDefault();
            
            functions.setUrlData(functions.getFormData($(e.target)), true);
            details.getParams();

            // datepicker-range
            details.params.dateTo = details.params.dateFrom.split(' - ')[1];
            details.params.dateFrom = details.params.dateFrom.split(' - ')[0];
            if (details.params.typeId == 51) details.params.guests += ',0';
            if (details.params.persons) details.params.guests = details.params.persons + ',0';
            
            details.getCalculation(null);

            if($('.form-arrangement')[0]) {
                $('.form-arrangement').removeClass('show');
            }
        });
    },
    setBookingUrlParams() {
        $('.btn-booking').on('click', e => {
            e.preventDefault();

            const index = $(e.currentTarget).attr('data-index');

            if ($(e.currentTarget).attr('data-unitid')) {
                details.params.unitId = $(e.currentTarget).attr('data-unitid');
            }

            if ($('.cruise-period').length) {
                details.params.dateTo = $('.cruise-period[value="' + details.params.dateFrom + '"]').attr('data-date-to');
            }

            if ($(e.currentTarget).closest('.form-arrangement')[0]) {
                const value = $(".datepicker-excursion[data-index=" + index + "]").val();
                details.params.dateFrom = value.split(' - ')[0];
                details.params.dateTo = value.split(' - ')[1];

                if (!details.params.dateTo) details.params.dateTo = details.params.dateFrom;
            }

            if(! details.params.dateFrom) {
                details.params.dateFrom = $('.datepicker[data-index="' + index + '"]').attr('data-defaultdate');
                details.params.dateTo = details.params.dateFrom;
            }

            var params = $.param({
                publicId: null,
                unitId: details.params.unitId,
                objectGroupId: details.params.objectGroupId,
                dateFrom: details.params.dateFrom,
                dateTo: details.params.dateTo,
                guests: details.params.guests
            });

            location = location.origin + '/' + $(e.currentTarget).attr('data-url') + '?' + params;

        });
    },
    setCalculationParams($bookingItem) {
        //details.params.objectGroupId = $bookingItem.attr('data-objectgroupid');
        details.params.unitId = $bookingItem.attr('data-unitid');

        //details.params.dateFrom = $bookingItem.find('[name="dateFrom"]').val();
        
        if($('.datepicker-range')[0]) {
            details.params.dateFrom = $bookingItem.find('.datepicker-range').attr('data-defaultdate');

            if(details.params.dateFrom) {
                details.params.dateTo = details.params.dateFrom.split(' - ')[1];
                details.params.dateFrom = details.params.dateFrom.split(' - ')[0];
            }

            if (!details.params.dateTo) details.params.dateTo = details.params.dateFrom;
        } else {
            details.params.dateFrom = $bookingItem.find('.datepicker').val();
            if(! details.params.dateFrom) details.params.dateFrom = $bookingItem.find('.datepicker').attr('data-defaultdate');
            details.params.dateTo = details.params.dateFrom;
        }

        details.params.guests = $bookingItem.find('[name="guests"]').val();

    },
    getCalculation(unitId = null) {

        if (!details.params.dateTo) details.params.dateTo = details.params.dateFrom;

        //console.log(details.params);

        return $.getJSON(
            location.protocol
            + '//'
            + location.hostname
            + '/services/calc.php'
            + (unitId ? ('?unitId=' + unitId) : ('?publicId=' + details.params.publicId)) 
            //+ 'unitId=' + unitId
            + '&guests=' + details.params.guests
            + '&dateFrom=' + details.params.dateFrom
            + '&dateTo=' + details.params.dateTo
            + '&objectGroupId=' + details.params.objectGroupId
            + '&lang=' + details.params.lang
        )
            .done(function (response) {
                const responseStatus = response.status;
                //console.log(response);
                
                Object.keys(response.data).forEach(unitId => {
                    const responseData = response.data[unitId];

                    const isAvailable = responseData.isAvailable;
                    //const bookingStatus = responseData.booking.status;

                    const isFree = $('.btn-booking').attr('data-isfree');
    
                    if(isFree) {
                        $('.btn-booking-' + unitId).prop('disabled', false);
                    }else if (responseStatus && isAvailable) {
                        let total = responseData.calc.total;
                        let totalConverted = responseData.calc.totalEUR;
                        const currencySymbol = responseData.calc.currencySymbol;

                        const dateFrom = new Date(details.params.dateFrom);
                        const dateTo = new Date(details.params.dateTo);

                        $('.dateFrom').text(dateFrom.getDate() + '.' + (dateFrom.getMonth()+1) + '.' + dateFrom.getFullYear() + '.');
                        $('.dateTo').text(dateTo.getDate() + '.' + (dateTo.getMonth()+1) + '.' + dateTo.getFullYear() + '.');

                        $('.dual-price-' + details.params.unitId).removeClass('d-none');
                        $('.calculated-price-converted-' + unitId).text(functions.formatMoney(totalConverted, 0, ',', '.'));
                        $('.details-unit-total-converted-' + unitId).text(functions.formatMoney(totalConverted, 0, ',', '.'));

                        $('.calculated-price-' + unitId).removeClass('text-accent');
                        $('.calculated-price-' + unitId).text(functions.formatMoney(total, 0, ',', '.') + ' ' + currencySymbol);

                        $('.details-unit-total-' + unitId).text(functions.formatMoney(total, 0, ',', '.') + ' ' + currencySymbol);
                        $('.btn-booking-' + unitId).prop('disabled', false);
                        $('.booking-message-' + unitId).text('Nećemo Vam još naplatiti.');
    
                        // CRUISE
                        if(details.params.typeId == 51) {
                            $('.details-unit-total-' + unitId).text(total);
                            if (details.params.persons == 1)
                                $('.details-unit-total-charge-' + unitId).removeClass('d-none');
                            else
                                $('.details-unit-total-charge-' + unitId).addClass('d-none');
                        }
                    } else {
                        if(details.params.dateFrom && details.params.guests) {
                            $('.booking-message-' + unitId).text('NIJE DOSTUPNO U ODABRANOM PERIODU!');
                            $('.calculated-price-' + unitId).text('Nije dostupno');
                            $('.calculated-price-' + unitId).addClass('text-accent');
                            $('.details-unit-total-' + unitId).text('Nije dostupno');
                            $('.dual-price-' + details.params.unitId).addClass('d-none');
                        }
                        $('.btn-booking-' + unitId).prop('disabled', true);
                    }
                });

            })
            .fail(function (error) {
                //console.log(error)
            });
    }
}